import styled from 'styled-components'

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  padding: 0;
  font-size: 1.4rem !important;
  font-weight: 600;
  color: #8660ec;
  cursor: pointer;
  align-self: flex-start;

  svg {
    font-size: 1.8rem;
  }
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;

  h1 {
    font-size: 2.4rem;
    line-height: 3rem;
    font-weight: 700;
    color: #2c2c2c;
    text-transform: capitalize;
  }

  .section-subtitle {
    font-size: 1.6rem !important;
    font-weight: 400;
    color: #4d4d4d;
  }
`

export const ExportButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  background: transparent;
  border: 1px solid #ff5100;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 1.4rem !important;
  font-weight: 600;
  color: #ff5100;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    font-size: 1.8rem;
  }
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`

export const Card = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #f0f0f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
`

export const CardTitle = styled.div`
  font-size: 1.2rem !important;
  font-weight: 400;
  color: #4d4d4d;
  margin-bottom: 12px;
`

export const CardValue = styled.div`
  font-size: 2.4rem;
  font-weight: 700;
  color: #393939;
`

export const ConsultationsCount = styled.div`
  font-size: 2.4rem;
  font-weight: 700;
  color: #393939;
`

export const ConsultationsList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
  padding: 0;

  li {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 1.2rem !important;
    font-weight: 400;
    color: #4d4d4d;
  }
`

export const RatesList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 12px;
  padding: 0;

  .rates-label {
    font-size: 1.2rem !important;
    font-weight: 400;
    color: #4d4d4d;
    margin-bottom: 2px;
  }

  li {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 1.2rem !important;
    font-weight: 400;
    color: #4d4d4d;
  }
`

export const StatusValue = styled.div<{ color: string }>`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1.6rem !important;
  font-weight: 600;
  color: ${({ color }) => color};
`

export const Dot = styled.span<{ color: string; size?: number }>`
  width: ${({ size = 8 }) => size}px;
  height: ${({ size = 8 }) => size}px;
  border-radius: 50%;
  background: ${({ color }) => color};
  flex-shrink: 0;
`

export const TableSection = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 20px;
  border: 0.91px solid #e2e2e2;
`

export const TableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;

  h2 {
    font-size: 1.6rem !important;
    font-weight: 600;
    color: #2c2c2c;
    margin: 0;
  }

  .count {
    font-size: 1.4rem !important;
    font-weight: 600;
    color: #8660ec;
  }
`

export const TableWrapper = styled.div`
  margin: 20px -20px 0;
  border-top: 0.91px solid #e2e2e2;
  overflow-x: auto;
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    text-align: left;
    padding: 12px 20px;
    white-space: nowrap;
  }

  th {
    font-size: 1.2rem !important;
    font-weight: 600;
    color: #4d4d4d;
    border-bottom: 1px solid #e2e2e2;
  }

  td {
    font-size: 1.4rem !important;
    font-weight: 400;
    color: #4d4d4d;
    border-bottom: 1px solid #f0f0f0;
  }
`

export const PatientCell = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 600 !important;
  color: #2c2c2c !important;
`

export const PatientAvatar = styled.span`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff1e0;
  color: #ff5100;
  font-size: 1.1rem !important;
  font-weight: 700;
`

export const SpecialtyTag = styled.span`
  color: #8660ec;
  font-weight: 500 !important;
`

export const ValueCell = styled.td`
  font-weight: 700 !important;
  color: #2c2c2c !important;
`

export const StatusBadge = styled.span<{ color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 1.2rem !important;
  font-weight: 600;
  color: ${({ color }) => color};
`

export const EmptyState = styled.div`
  padding: 24px 0;
  text-align: center;
  font-size: 1.4rem !important;
  color: ${({ theme }) => theme.colors.gray80};
`

export const TableFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 16px;

  .showing {
    font-size: 1.4rem !important;
    color: #8660ec;
  }
`

export const PaginationWrapper = styled.div`
  .MuiPagination-ul {
    gap: 6px;
  }

  .MuiPaginationItem-root {
    width: 32px;
    height: 32px;
    min-width: 32px;
    border-radius: 50%;
    border: 1px solid #e2e2e2;
    color: #2c2c2c;
    font-size: 1.4rem !important;
    font-weight: 600;
  }

  .MuiPaginationItem-root.Mui-selected {
    background-color: #ff5100;
    border-color: #ff5100;
    color: #ffffff;
  }

  .MuiPaginationItem-root.Mui-selected:hover {
    background-color: #ff5100;
  }

  .MuiPaginationItem-ellipsis {
    border: none;
  }
`
